<template>
    <div class="bottom-wrapper" >
        <div class="nav-bottom flex flex-pack-around">
            <i class="iconfont icon-back" @click="goBack" ></i>
            <router-link tag="i" class="iconfont icon-home" :to="{ name:'Home' }" ></router-link>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/bottom.vue